import { ComponentProps } from 'react';
import { RefreshCwIcon } from 'lucide-react';

import { StaggerFieldsetFields } from '@/react/edge/edge-stacks/components/StaggerFieldset';

import { Card } from '@@/primitives/Card';

type Props = Pick<
  ComponentProps<typeof StaggerFieldsetFields>,
  'values' | 'onChange' | 'errors'
>;

export function UpdateConfiguration({ values, onChange, errors }: Props) {
  return (
    <Card.Container>
      <Card.Header title="Updates configuration" icon={RefreshCwIcon} />
      <Card.Body>
        <StaggerFieldsetFields
          isEdit={false}
          values={values}
          errors={errors}
          onChange={onChange}
        />
      </Card.Body>
    </Card.Container>
  );
}
